module.exports = __webpack_public_path__ + "static/media/plus.c491a980.svg";